<template>
  <div>
    <my-header :page_name="$t('navigation.headerTitles.passwordChange')" show_usermenu></my-header>
    <el-form>
      <el-form-item :label="$t('passwordChange.oldPass')">
        <el-input v-model="oldPassword" show-password></el-input>
      </el-form-item>
      <el-form-item :label="$t('passwordChange.newPass')">
        <el-input v-model="newPassword" show-password></el-input>
      </el-form-item>
      <el-button @click="changePasswordClick"> {{ $t('passwordChange.change') }}</el-button>
    </el-form>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      oldPassword: null,
      newPassword: null
    };
  },
  methods: {
    changePasswordClick() {
      if (this.oldPassword && this.newPassword) {
        this.$store.commit("setLoading", true);
        this.$store
          .dispatch("changePassword", {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
            userId: null
          })
          .then(() => {
            this.$store.commit("setLoading", false);
            //console.log("All done");
            this.newPassword = null;
            this.oldPassword = null;
          })
          .catch(() => {
            this.$store.commit("setLoading", false);
          });
      }
    }
  },
  components: {
    myHeader: Header
  },
  computed: {
    ...mapGetters(['getUser'])
  }
};
</script>

<style scoped>
.el-form {
  max-width: 450px;
  margin: auto;
  margin-top: 2em;
  padding: 1em 2em;
  padding-bottom: 2em;
  border: 2px solid var(--main-background);
}
.el-button {
  width: 100%;
  margin-top: 1em;
}
</style>